import {
  Form,
  Button,
  Input,
  InputNumber,
  Select,
  Typography,
  Space,
  Tooltip,
  Switch,
  Card,
  Col,
  Row,
} from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import { useState } from "react";
import { labelConfig } from "../../../contractbooking.config";
import { BOM } from "../../../../../services/definedMethod";

const { Title, Paragraph } = Typography;
const { Option } = Select;

const CounterpartyForm = ({
  onFinish,
  form,
  initialValues,
  templateProdDetail,
  counterPartyData,
  setSendDealConfirmation,
  sendDealConfirmation,
  // onChangeBranch,
}) => {
  // const [sendDealConfirmation, setSendDealConfirmation] = useState(
  //   // templateProdDetail.CounterParty?.sendDealConfirmation
  //   false
  // );

  console.log(sendDealConfirmation);
  // const handleValuesChange = (changedValues, allValues) => {
  //   updateFormData(allValues);
  // };

  const handleSearch = () => {
    // Implement bank search functionality
    console.log("Searching for bank...");
  };

  return (
    <div className="form-section">
      <h2 style={{ fontSize: "24px", margin: 0 }}>Counterparty Information</h2>
      <p style={{ marginTop: "5px", color: "#6b7280" }}>
        Counterparty Details Associated With Contract.
      </p>

      <Form
        form={form}
        layout="vertical"
        initialValues={initialValues}
        onFinish={onFinish}
        // onValuesChange={handleValuesChange}
      >
        <Row>
          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={
                <Space>
                  {labelConfig.branchCode}
                  <Tooltip title="Enter the product code">
                    <InfoCircleOutlined />
                  </Tooltip>
                </Space>
              }
              name={"bankCode"}
              rules={[
                {
                  required: true,
                  message: BOM.CheckReqFld(labelConfig.branchCode),
                },
              ]}
            >
              {/* <Select
                showSearch
                // disabled={!showDetailsForm}
                allowClear
                filterOption={(input, option) =>
                  (option?.label?.toLowerCase() ?? "").includes(
                    input?.toLowerCase()
                  )
                }
                placeholder={BOM.handlePlaceholderMsg(
                  labelConfig.branchCode,
                  "select"
                )}
                // placeholder="Search by product code"
                optionFilterProp="children"
                style={{ height: "44px" }}
                // onChange={onChangeBranch}
                options={counterPartyData}
              /> */}
              <Input
                placeholder="---"
                disabled
                style={{ height: "44px" }}
                className="of-bold-disable-input"
              />
            </Form.Item>
          </Col>

          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={
                <Space>
                  Bank Name
                  <Tooltip title="Bank name">
                    <InfoCircleOutlined />
                  </Tooltip>
                </Space>
              }
              name={"bankName"}
            >
              <Input
                placeholder="---"
                disabled
                style={{ height: "44px" }}
                className="of-bold-disable-input"
              />
            </Form.Item>
          </Col>

          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={
                <Space>
                  KYC Status
                  <Tooltip title="Know Your Customer status">
                    <InfoCircleOutlined />
                  </Tooltip>
                </Space>
              }
              name="kycStatus"
            >
              <Input
                placeholder="Verified/Unverified"
                disabled
                style={{ height: "44px" }}
                className="of-bold-disable-input"
              />
            </Form.Item>
          </Col>
          {/* <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={
                <Space>
                  Status
                  <Tooltip title="Know Your Customer status">
                    <InfoCircleOutlined />
                  </Tooltip>
                </Space>
              }
              name="status"
            >
              <Input
                placeholder="Verified/Unverified"
                disabled
                style={{ height: "44px" }}
                className="of-bold-disable-input"
              />
            </Form.Item>
          </Col> */}

          <Col span={12} style={{ padding: "0px 8px" }}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                height: "100%",
                maxWidth: 250,
              }}
            >
              <span>Send Deal Confirmation</span>
              <Form.Item
                name={"sendDealConfirmation"}
                valuePropName="checked"
                noStyle
              >
                <Switch
                  onChange={(checked) => setSendDealConfirmation(checked)}
                />
              </Form.Item>
            </div>
          </Col>
          {sendDealConfirmation && (
            <Col span={12} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={
                  <Space>
                    Email
                    <Tooltip title="User email">
                      <InfoCircleOutlined />
                    </Tooltip>
                  </Space>
                }
                name="email"
              >
                <Input
                  placeholder="Verified/Unverified"
                  disabled
                  style={{ height: "44px" }}
                  className="of-bold-disable-input"
                />
              </Form.Item>
            </Col>
          )}

          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={
                <Space>
                  Institution Code
                  <Tooltip title="Institution code">
                    <InfoCircleOutlined />
                  </Tooltip>
                </Space>
              }
              name={"institutionCode"}
            >
              <Input
                disabled
                placeholder="001"
                style={{ height: "44px" }}
                className="of-bold-disable-input"
              />
            </Form.Item>
          </Col>
          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={
                <Space>
                  Account Number
                  <Tooltip title="External Deal Account Number">
                    <InfoCircleOutlined />
                  </Tooltip>
                </Space>
              }
              name={"externalDealAccountNumber"}
            >
              <Input
                disabled
                placeholder="1234567890"
                style={{ height: "44px" }}
                className="of-bold-disable-input"
              />
            </Form.Item>
          </Col>
          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={
                <Space>
                  Current Utilization
                  <Tooltip title="Current utilization">
                    <InfoCircleOutlined />
                  </Tooltip>
                </Space>
              }
              name={"currentLimitUtilizationLcy"}
            >
              <InputNumber
                className="of-bold-disable-input"
                disabled
                style={{ width: "100%", height: "44px" }}
                placeholder="900,000,000,000"
                prefix="₦"
                formatter={(value) =>
                  `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }
                parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
              />
            </Form.Item>
          </Col>
          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={
                <Space>
                  Maximum Limit
                  <Tooltip title="Maximum limit">
                    <InfoCircleOutlined />
                  </Tooltip>
                </Space>
              }
              name={"maxLimitAmountLcy"}
            >
              <InputNumber
                className="of-bold-disable-input"
                disabled
                style={{ width: "100%", height: "44px" }}
                placeholder="900,000,000,000"
                prefix="₦"
                formatter={(value) =>
                  `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }
                parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default CounterpartyForm;

// <InputNumber
//                 style={{ height: "44px", width: "100%" }}
//                 placeholder="10,000,000,000"
//                 formatter={(value) =>
//                   `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
//                 }
//                 parser={(value) => (value ? value.replace(/(,*)/g, "") : "")}
//               />
